import React from "react";
import { Marker } from "react-map-gl/mapbox";
import Typography from "@mui/material/Typography";

// Small white chip pinned at a polygon centroid showing its area/perimeter.
// Shared by the draw view (PolygonMetricsLabels) and the history view
// (HistoryAreaPolygons) so both render identically.
export default function MetricLabelMarker({
  longitude,
  latitude,
  primary,
  secondary,
}) {
  if (longitude == null || latitude == null) return null;

  return (
    <Marker longitude={longitude} latitude={latitude} anchor="center">
      <div
        style={{
          background: "rgba(255, 255, 255, 0.92)",
          borderRadius: 6,
          padding: "3px 8px",
          boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
          whiteSpace: "nowrap",
          textAlign: "center",
          color: "#1a1a1a",
          pointerEvents: "none",
        }}
      >
        <Typography
          component="div"
          sx={{ fontSize: 12, lineHeight: 1.35, fontWeight: 600 }}
        >
          {primary}
        </Typography>
        <Typography
          component="div"
          sx={{ fontSize: 12, lineHeight: 1.35, opacity: 0.75 }}
        >
          {secondary}
        </Typography>
      </div>
    </Marker>
  );
}
